import { render, staticRenderFns } from "./TrainIcon.vue?vue&type=template&id=ffd438c8&"
import script from "./TrainIcon.vue?vue&type=script&lang=js&"
export * from "./TrainIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports